import React, {} from 'react';
import Popup from "reactjs-popup";
import {SubtitleContext} from "../../contexts/SubtitleContext";
import ZeroTimeMainView from "../layout/ZeroTime/ZeroTimeMainView";
import TimeUtils from "../../helper/TimeUtils";

const RunZerotime_Popup = ({_WaveformView}) => {

    return <Popup
        open={_WaveformView.state.isShowRunZerotime}
        modal
        closeOnDocumentClick
        onClose={()=>{
            _WaveformView.setState({isShowRunZerotime:false });
        }}
        contentStyle={{width:'800px' }}
    >
        <SubtitleContext.Consumer>
            {context =>
                <ZeroTimeMainView
                    context={context}
                    closeTranslationsNavbarAlertView={()=>{
                        _WaveformView.setState({isShowRunZerotime:false });
                    }}
                    projectDetial={_WaveformView.projectDetial}
                    runZeroTime={async (way,lastDataIndex,zeroTimeTitle)=>{
                        //預設
                        const {videoFps} = _WaveformView.props.transOperation;

                        let distance = TimeUtils.timeString_convertTo_frame(zeroTimeTitle) * way;

                        /** 把所有的開始跟結束時間都加上距離 */
                        _WaveformView.activeTimecodeshift(videoFps,_WaveformView.findFrameSplitValue,distance,0, (_WaveformView.DataObjArray.getLength()-1));

                        //關閉
                        _WaveformView.setState({isShowRunZerotime:false,isShowTranslationsNavbarAlert:false});
                    }}
                />
            }
        </SubtitleContext.Consumer>
    </Popup>;
};

export default RunZerotime_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/RunZerotime_Popup.js